<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="titlepage">
<a id="page03">
<h2 class="titlePageTitle" style="text-indent: 0%;">Psychic</h2>
<p class="titlePageSubtitle" style="text-indent: 0%;">My Life in Two Worlds</p>
<h2 class="titlePageAuthor" style="text-indent: 0%;">Sylvia Browne</h2>
<h2 class="titlePageAuthor1" style="text-indent: 0%;">With Lindsay Harrison</h2>
<p class="colophon"><img alt="image" class="epubimage" src="Images/logo.jpg"/></p>
</a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?5fe9d81e